import styled from 'styled-components';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export const StyledCheckbox = styled(Checkbox)`
  && {
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 6px;
    margin-left: 10px;
    padding: 0px;
    color: #76838f;
    &.Mui-checked {
      .MuiSvgIcon-root {
        fill: ${({ $checkedColor }) => $checkedColor || '#5fb1f3'};
      }
    }
    .MuiSvgIcon-root {
      fill: #76838f
    }
  }
`;
export const StyledFormControlLabel = styled(FormControlLabel)`
  width: 100%;
  padding: 0px;
  margin: 0px;
  && {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1rem;
    font-weight: 400 !important;
    line-height: 1.2rem;
    text-transform: uppercase;

    .Mui-disabled {
      cursor: not-allowed;
      pointer-events: visible;
      & > span:first-child {
        background: rgba(206, 217, 224, 0.5);
      }
    }

    .MuiTypography-root {
      color: ${(props) => props.$labelColor};
      font-weight: ${(props) => props.$labelWeight};
    }
  }
`;
